import moment from 'moment';
import { normalizeTrackingStatus } from "../../../services/helpers/status";
import { camelCase } from "change-case";

const APItoOrder = (i) => {
    let data = {
        cancellationReason: i.cancellationReason,
        courierTrackingId: i.courier.trackingId,
        courierWaybillId: i.courier.waybillId,
        courierCompany: i.courier.company,
        courierType: i.courier.type,
        courierName: i.courier.name,
        courierPhone: i.courier.phone,
        courierLink: i.courier.link,
        courierInsuranceAmount: i.courier.insurance ? i.courier.insurance.amount : null,
        courierInsuranceFee: i.courier.insurance ? i.courier.insurance.fee : null,
        createdAt: i.createdAt,
        deliveryType: i.delivery.type,
        deliveryDate: i.delivery.date,
        deliveryTime: i.delivery.time,
        deliveryNote: i.delivery.note,
        fulfillmentOrderId: i.fulfillment ? i.fulfillment.fulfillmentOrderId : null,
        fulfillmentServiceId: i.fulfillment ? i.fulfillment.fulfillmentServiceId : null,
        fulfillmentServiceCode: i.fulfillment ? i.fulfillment.fulfillmentServiceCode : null,
        fulfillmentServiceName: i.fulfillment ? i.fulfillment.fulfillmentServiceName : null,
        fulfillmentStatus: i.fulfillment ? i.fulfillment.status : null,
        extra: i.extra,
        items: i.items,
        loading:false,
        orderId: i._id,
        orderType: i.type,
        originName: i.origin.name,
        originLocation: i.origin.location,
        originLatitude: i.origin.coordinate ? i.origin.coordinate.latitude : null,
        originLongitude: i.origin.coordinate ? i.origin.coordinate.longitude : null,
        originCoordinate: i.origin.coordinate,
        originEmail: i.origin.email,
        originPhone: i.origin.phone,
        originPostalCode: i.origin.postalCode,
        originNote: i.origin.note,
        orderNote: i.note,
        price: i.price,
        paymentType: i.paymentType,
        paymentSlip: i.images.paymentSlip,
        paymentMethod: i.paymentMethod,
        shipperName: i.shipper.name,
        shipperEmail: i.shipper.email,
        shipperPhone: i.shipper.phone,
        shipperOrganization: i.shipper.organization,
        shipperUserId: i.userId,
        receiverName: i.receiver.name,
        receiverPhone: i.receiver.phone,
        receiverLocation: i.receiver.location,
        receiverCoordinate: i.receiver.coordinate,
        receiverPostalCode: i.receiver.postalCode,
        receiverLatitude: i.receiver.coordinate ? i.receiver.coordinate.latitude : null,
        receiverLongitude: i.receiver.coordinate ? i.receiver.coordinate.longitude : null,
        receiverEmail: i.receiver.email,
        receiverNote:i.receiver.note,
        receiptLink: i.receiptLink,
        receiverPODFee: i.receiver.proofOfDelivery.use ? i.receiver.proofOfDelivery.fee : null,
        receiverCODAmount: i.receiver.cashOnDelivery ? i.receiver.cashOnDelivery.amount : null,
        receiverCODFee: i.receiver.cashOnDelivery ? i.receiver.cashOnDelivery.fee : null,
        receiverCODNote: i.receiver.cashOnDelivery ? i.receiver.cashOnDelivery.note : null,
        receiverCODType: i.receiver.cashOnDelivery ? i.receiver.cashOnDelivery.type : null,
        receiverCODStatus: i.receiver.cashOnDelivery ? i.receiver.cashOnDelivery.status : null,
        selected: false,
        status: camelCase(i.status),
        tags: i.tags ? i.tags.split(",") : [], 
        weight: i.weight
    }
    return data
}

const OpenAPItoOrder = (i) => {
    let history = i.courier.history.reduce((r,i) => {
        r.push({
            eventDate:i.updated_at,
            status: normalizeTrackingStatus(i.status),
            note: i.note
        });
        return r
    },[]);

    let weight = i.items.reduce((r,i) => {
        r = parseInt(r) + parseInt(i.weight);
        return r
    },0);
    
    let data = {
        courierTrackingId: i.courier.tracking_id,
        courierWaybillId: i.courier.waybill_id,
        courierCompany: i.courier.company,
        courierType: i.courier.type,
        courierName: i.courier.name,
        courierPhone: i.courier.phone,
        courierLink: i.courier.link,
        courierHistory:history,
        courierInsuranceAmount: i.courier.insurance ? i.courier.insurance.amount : null,
        courierInsuranceFee: i.courier.insurance ? i.courier.insurance.fee : null,
        createdAt: i.created_at,
        deliveryType: i.delivery.type,
        deliveryDate: moment(i.delivery.datetime,"YYYY-MM-DD").format("YYYY-MM-DD"),
        deliveryTime: moment(i.delivery.datetime,"YYYY-MM-DD").format("HH:mm"),
        deliveryNote: i.delivery.note,
        items: i.items,
        loading:false,
        orderId: i.id,
        weight: weight,
        originName: i.origin.contact_name,
        originLocation: i.origin.address,
        originCoordinate: i.origin.coordinate,
        originPhone: i.origin.contact_phone,
        originNote: i.origin.note,
        orderNote: i.note,
        price: i.price,
        receiverName: i.destination.contact_name,
        receiverPhone: i.destination.contact_phone,
        receiverLocation: i.destination.address,
        receiverCoordinate: i.destination.coordinate,
        receiverNote:i.destination.note,
        receiverPODFee: i.destination.proof_of_delivery.use ? i.destination.proof_of_delivery.fee : null,
        receiverCODAmount: i.destination.cash_on_delivery ? i.destination.cash_on_delivery.amount : null,
        receiverCODFee: i.destination.cash_on_delivery ? i.destination.cash_on_delivery.fee : null,
        receiverCODNote: i.destination.cash_on_delivery ? i.destination.cash_on_delivery.note : null,
        selected: false,
        status: camelCase(i.status)
    }
    return data
}

const orderNumberByStatus = (data) => {
    const placed = data.filter(i => i.status === 'placed')[0] ? data.filter(i => i.status === 'placed')[0].total : 0
    const confirmed = data.filter(i => i.status === 'confirmed')[0] ? data.filter(i => i.status === 'confirmed')[0].total :  0
    const scheduled = data.filter(i => i.status === 'scheduled')[0] ? data.filter(i => i.status === 'scheduled')[0].total :  0
    const allocated = data.filter(i => i.status === 'allocated')[0] ? data.filter(i => i.status === 'allocated')[0].total :  0
    const pickingUp = data.filter(i => i.status === 'picking_up')[0] ? data.filter(i => i.status === 'picking_up')[0].total :  0
    const picked = data.filter(i => i.status === 'picked')[0] ? data.filter(i => i.status === 'picked')[0].total :  0
    const droppingOff = data.filter(i => i.status === 'dropping_off')[0] ? data.filter(i => i.status === 'dropping_off')[0].total :  0
    const onHold = data.filter(i => i.status === 'on_hold')[0] ? data.filter(i => i.status === 'on_hold')[0].total :  0
    const pending = data.filter(i => i.status === 'pending')[0] ? data.filter(i => i.status === 'pending')[0].total : 0
    const disposed = data.filter(i => i.status === 'disposed')[0] ? data.filter(i => i.status === 'disposed')[0].total : 0
    const returnInTransit = data.filter(i => i.status === 'return_in_transit')[0] ? data.filter(i => i.status === 'return_in_transit')[0].total : 0
    const returned = data.filter(i => i.status === 'returned')[0] ? data.filter(i => i.status === 'returned')[0].total : 0
    const cancelled = data.filter(i => i.status === 'cancelled')[0] ? data.filter(i => i.status === 'cancelled')[0].total : 0
    const delivered = data.filter(i => i.status === 'delivered')[0] ? data.filter(i => i.status === 'delivered')[0].total : 0
    const courierNotFound = data.filter(i => i.status === 'courier_not_found')[0] ? data.filter(i => i.status === 'courier_not_found')[0].total : 0
    const rejected = data.filter(i => i.status === 'rejected')[0] ? data.filter(i => i.status === 'rejected')[0].total : 0
    let newData = {
        pending:pending,
        placed:placed,
        scheduled:scheduled,
        cancelled:cancelled,
        delivered:delivered,
        courierNotFound:courierNotFound,
        rejected:rejected,
        confirmed:confirmed,
        allocated:allocated,
        pickingUp:pickingUp,
        picked:picked,
        disposed:disposed,
        returnInTransit:returnInTransit,
        returned:returned,
        droppingOff:droppingOff,
        onHold:onHold,
        preActive:scheduled+placed,
        active:confirmed+allocated+pickingUp+picked+droppingOff+onHold,
        notActive:cancelled+delivered+courierNotFound+rejected
    }

    return newData
}


export const dataToDownload = (data) => {
    const newData = data.reduce((r,i,idx) => {
        r.push({
            no:idx+1,
            order_id:i._id,
            short_order_id:i.shortId,
            user_id:i.userId,
            shipper_name:i.shipper.name,
            shipper_organization:i.shipper.organization,
            shipper_email:i.shipper.email,
            shipper_phone:i.shipper.phone,
            origin_name:i.origin.name,
            origin_phone:i.origin.phone,
            origin_address:i.origin.location,
            origin_note:i.origin.note,
            origin_postal_code:i.origin.postalCode,
            destination_name:i.receiver.name,
            destination_phone:i.receiver.phone,
            destination_address:i.receiver.location,
            destination_note:i.receiver.note,
            destination_postal_code:i.receiver.postalCode,
            courier_code:i.courier.company,
            courier_service_code:i.courier.type,
            courier_tracking_id:i.courier.trackingId,
            courier_link:i.courier.link,
            confirmed_date:i.confirmedAt ? moment(i.confirmedAt).format("YYYY-MM-DD") : "",
            confirmed_time:i.confirmedAt ? moment(i.confirmedAt).format("HH:mm:ss") : "",
            waybill_id:i.courier.waybillId,
            delivery_type:i.delivery.type,
            delivery_date:i.delivery.date,
            delivery_time:i.delivery.time,
            total_weight:i.weight,
            total_volume:i.volume,
            total_quantity:i.quantity,
            note:i.note,
            item_name:i.items[0].name || "",
            item_description:i.items[0].description || "",
            item_value:i.items[0].value || 0,
            item_length:i.items[0].quantity || 10,
            item_width:i.items[0].width || 10,
            item_height:i.items[0].height || 10,
            item_weight:i.items[0].weight || 1000,
            item_quantity:i.items[0].quantity || 1,
            request_type:i.requestType,
            basic_price:i.courier.shipmentFee,
            cod_amount:i.receiver.cashOnDelivery ? i.receiver.cashOnDelivery.amount : 0,
            cod_fee:i.receiver.cashOnDelivery ? i.receiver.cashOnDelivery.fee : 0,
            insurance_amount:i.courier.insurance ? i.courier.insurance.amount : 0,
            insurance_fee:i.courier.insurance ? i.courier.insurance.fee : 0,
            price:i.price,
            status:i.status,
            cancellation_reason:i.cancellationReason,
            created_date:moment(i.createdAt).format("YYYY-MM-DD"),
            created_time:moment(i.createdAt).format("HH:mm:ss")
        });

        if (i.items.length > 1) {
            for (let j=1; j < i.items.length; j++) {
                r.push({
                    no:idx+1,
                    order_id:i._id,
                    short_order_id:i.shortId,
                    user_id:i.userId,
                    shipper_name:i.shipper.name,
                    shipper_organization:i.shipper.organization,
                    shipper_email:i.shipper.email,
                    shipper_phone:i.shipper.phone,
                    origin_name:i.origin.name,
                    origin_phone:i.origin.phone,
                    origin_address:i.origin.location,
                    origin_note:i.origin.note,
                    origin_postal_code:i.origin.postalCode,
                    destination_name:i.receiver.name,
                    destination_phone:i.receiver.phone,
                    destination_address:i.receiver.location,
                    destination_note:i.receiver.note,
                    destination_postal_code:i.receiver.postalCode,
                    courier_code:i.courier.company,
                    courier_service_code:i.courier.type,
                    courier_tracking_id:i.courier.trackingId,
                    courier_link:i.courier.link,
                    confirmed_date:i.confirmedAt ? moment(i.confirmedAt).format("YYYY-MM-DD") : "",
                    confirmed_time:i.confirmedAt ? moment(i.confirmedAt).format("HH:mm:ss") : "",
                    waybill_id:i.courier.waybillId,
                    delivery_type:i.delivery.type,
                    delivery_date:i.delivery.date,
                    delivery_time:i.delivery.time,
                    total_weight:i.weight,
                    total_volume:i.volume,
                    total_quantity:i.quantity,
                    note:i.note,
                    item_name:i.items[j].name || "",
                    item_description:i.items[j].description || "",
                    item_value:i.items[j].value || 0,
                    item_length:i.items[j].quantity || 10,
                    item_width:i.items[j].width || 10,
                    item_height:i.items[j].height || 10,
                    item_weight:i.items[j].weight || 1000,
                    item_quantity:i.items[j].quantity || 1,
                    request_type:i.requestType,
                    basic_price:i.courier.shipmentFee,
                    cod_amount:i.receiver.cashOnDelivery ? i.receiver.cashOnDelivery.amount : 0,
                    cod_fee:i.receiver.cashOnDelivery ? i.receiver.cashOnDelivery.fee : 0,
                    insurance_amount:i.courier.insurance ? i.courier.insurance.amount : 0,
                    insurance_fee:i.courier.insurance ? i.courier.insurance.fee : 0,
                    price:i.price,
                    status:i.status,
                    cancellation_reason:i.cancellationReason,
                    created_date:moment(i.createdAt).format("YYYY-MM-DD"),
                    created_time:moment(i.createdAt).format("HH:mm:ss")
                });
            }
        }

        return r;
    },[])
    return newData
}


export default {
    APItoOrder,
    OpenAPItoOrder,
    orderNumberByStatus,
    dataToDownload
}